import {ErrorData} from 'packages/errors/errors';
import {put} from 'packages/rest/api';

export async function ResendPhoneVerificationAPI(): Promise<ErrorData | null> {
    const res = await put({url: 'session/phones/verifications'});
    return res[1];
}
